module.exports = __webpack_public_path__ + "assets/img/share-own-qr.de6eb7ee.png";